/**
 * This slice is containing the information for a user
 */

import { createSlice , createAsyncThunk } from '@reduxjs/toolkit';
import { logInUser , createUser, signInWithGoogleFirebase} from '../persistence/firestoreModelUser.js';
import { makeUserObj } from '../persistence/firestoreUtils.js';
import { loadUserFromStorage, saveUserToStorage, clearAllStorage } from '../storageUtils.js';
import SignInError from '../errors/SignInError.js';
import { act } from 'react';
import { action } from 'mobx';



async function signInthunk({email, password}, thunkAPI){
    try {
        let userCredential = await logInUser(email, password);
        let userObj = await makeUserObj(userCredential.user.uid);
        console.log(userObj)
        return userObj; // blir paylode i succses
    }
    catch(error){
        console.log("error i signInthunk:", error.code)
        console.log("error i signInthunk:", error.message)
    const serializable = { code: error?.code || 'auth/unknown', message: error?.message || 'Unknown error' };
    return thunkAPI.rejectWithValue(serializable); // blir payload i failure (serializable)
    }
}
async function signUpthunk({email, password, comfirmPassword, FName, LName}, thunkAPI) {
    try {
        if(password!==comfirmPassword)
            throw new SignInError('auth/password-mismatch', 'Passwords do not match');
        if(FName.trim() === '')
            throw new SignInError('auth/empty-first-name', 'First name cannot be empty');
        if(LName.trim() === '')
            throw new SignInError('auth/empty-last-name', 'Last name cannot be empty');
        let userCredential = await createUser(email, password, FName, LName);
        let userObj = await makeUserObj(userCredential.user.uid);
        console.log(userObj);
        return userObj; // blir paylode i succses
    } catch (error) {
        console.log("error i signInthunk:", error.code)
        console.log("error i signInthunk:", error.message)
      const serializable = { code: error?.code || 'auth/unknown', message: error?.message || 'Unknown error' };
      return thunkAPI.rejectWithValue(serializable); // blir payload i failure (serializable)
    }
}

async function signInWithGoogleThunk(_, thunkAPI){
  try{
    const userCredential = await signInWithGoogleFirebase();
    const user = await makeUserObj(userCredential.uid);
    return user;
  } catch(error){
    console.error("Error in signInWithGoogleThunk:", error);
    const serializable = { 
              code: error?.code || 'auth/unknown', 
              message: error?.message || 'Unknown error' 
          };
    return thunkAPI.rejectWithValue(serializable);
  }
}

export const signIn = createAsyncThunk("user/signin",signInthunk);
export const signUp = createAsyncThunk("user/signUp",signUpthunk);
export const signInWithGoogle = createAsyncThunk("user/signInWithGoogle", signInWithGoogleThunk);

function applyUserToState(state, user) {
    state.currentUser = user.uid;
    state.username = user.userName;
    state.userEmail = user.email;
    state.userClubs = user.userClubs;
    state.userIMG = user.userIMG;
    state.userRequests = user.userRequests;

}

function exsplainPayload(code) {
  switch (code) {

    case 'auth/invalid-email':
      return {emailError :'Invalid-email.'};
    case 'auth/invalid-credential':
      return {networkError: 'Wrong email or password.'};
    case 'auth/email-already-in-use':
      return {emailError: 'Email already in use.'};
    case 'auth/empty-first-name':
      return {fNameError: 'First name cannot be empty.'};
    case 'auth/empty-last-name':
      return {lNameError: 'Last name cannot be empty.'};
    case 'auth/password-mismatch':
      return {passwordError: 'Passwords do not match.'};
    case 'auth/password-does-not-meet-requirements':
      return {passwordError: 'Weak password. At least 6 characters, contain numbers and capital letters.'};
    case 'auth/network-request-failed':
      return {networkError: 'Network error. Check your connection.'};
    case 'auth/too-many-requests':
      return {networkError: 'Too many attempts. Try again later.'};
    default:
      return {networkError: 'Something went wrong. Please try again.'};
  }
}


const persistedUser = loadUserFromStorage();

const userSlice = createSlice({
    name: 'user',
    initialState: {
        currentUser: persistedUser?.currentUser || "", //id för den inloggade användaren: mock "LTu7zdChfIcdMap5zkAmdceyYU93"
        username: persistedUser?.username || "", //namn på den inloggade användaren
        userEmail: persistedUser?.userEmail || "", //email för den inloggade användaren
        userIMG: persistedUser?.userIMG || "", //bild för den inloggade användaren
        userClubs: persistedUser?.userClubs || [], //array med id för alla klubbar som användaren är medlem i
        userRequests: persistedUser?.userRequests || [],
        status: "",
        error: null,
    },
    reducers: {
        clearErrors(state){
            state.error = null;
        },
        addPendingRequestUser(state, action){
          // Always add as raw id initially; enrichment to object happens via snapshot
          if(!state.userRequests){
            state.userRequests = []
          }

          const clubId = action.payload.clubId;
          const exists = state.userRequests.some(req => (req?.clubId ?? req?.id ?? req) === clubId);
          if (!exists) {
            state.userRequests.push(clubId);
          }
        },

        removePendingRequestUser(state, action){
          const clubId = action.payload.clubId;
          state.userRequests = state.userRequests.filter(req => {
            if (typeof req === 'object') {
              return (req.clubId ?? req.id) !== clubId;
            }
            return req !== clubId;
          })
        },

        addUserClub(state, action){
            if(!state.userClubs.includes(action.payload.clubId))
                state.userClubs.push(action.payload.clubId);   
        },

        updateUserClubsList(state, action){
            state.userClubs = action.payload.userClubs;
        },

        updateUserRequestsList(state, action){
          // Normalize to objects to satisfy UI expectation after enrichment
          const list = action.payload.pendingRequests || [];
          state.userRequests = list.map(req => (typeof req === 'object' ? req : { clubId: String(req) }));
        },
        
        signOut(state){
            state.currentUser = "";
            state.username = "";
            state.userEmail = "";
            state.userIMG = "";
            state.userClubs = [];
            state.userRequests = []
            state.status = "signed-out";
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
          .addCase(signIn.pending, (state) => {
            state.status = "pending";
            state.error = null;
          })
          .addCase(signIn.fulfilled, (state, action) => {
            state.status = "signed-in";
            console.log("action.payload i userSlice:", action.payload);
            applyUserToState(state, action.payload);
          })
          .addCase(signIn.rejected, (state, action) => {
            state.status = "rejected";
            state.error = exsplainPayload(action.payload.code);
          })
          .addCase(signUp.pending, (state) => {
            state.status = "pending";
            state.error = null;
          })
          .addCase(signUp.fulfilled, (state, action) => {
            state.status = "signed-in";
            console.log("action.payload i userSlice:", action.payload);
            applyUserToState(state, action.payload);
          })
          .addCase(signUp.rejected, (state, action) => {
            state.status = "rejected";
            state.error = exsplainPayload(action.payload.code);
            //state.error = action.payload;
          })
          .addCase(signInWithGoogle.pending, (state) => {
            state.status = "pending";
            state.error = null;
          })
          .addCase(signInWithGoogle.fulfilled, (state, action) => {
            state.status = "signed-in";
            console.log("action.payload i userSlice:", action.payload);
            applyUserToState(state, action.payload);
          })
          .addCase(signInWithGoogle.rejected, (state, action) => {
            state.status = "rejected";
            state.error = exsplainPayload(action.payload.code);
          });

      },
})

export const {addPendingRequestUser, removePendingRequestUser, addUserClub, updateUserRequestsList, updateUserClubsList, signOut, clearErrors} = userSlice.actions;
export default userSlice.reducer;

